// Generated from SVG to Code Figma Plugin

export const ProStudioBlack = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M5.53792 3.91893C6.9843 2.47254 9.32936 2.47254 10.7757 3.91893L20.3032 13.4464C21.7496 14.8928 21.7496 17.2379 20.3032 18.6842L17.92 21.0675C17.5584 21.4291 16.9722 21.4291 16.6106 21.0675L3.15471 7.6116C2.79311 7.25 2.79311 6.66374 3.1547 6.30214L5.53792 3.91893Z"
      stroke="url(#paint0_linear_926_3573)"
      strokeWidth="1.5"
    />
    <path
      d="M5.7999 9.31395L8.15692 6.95693"
      stroke="url(#paint1_linear_926_3573)"
      strokeLinecap="round"
      strokeWidth="1.5"
    />
    <path
      d="M14.5855 18.7426L16.9425 16.3856"
      stroke="url(#paint2_linear_926_3573)"
      strokeLinecap="round"
      strokeWidth="1.5"
    />
    <path
      d="M4.13748 15.1847C3.37704 15.946 2.94989 16.978 2.94989 18.0541V21.3H6.21912C7.29623 21.3 8.3292 20.872 9.09067 20.1102L20.4798 8.71649C21.8441 7.35154 21.8442 5.13913 20.4798 3.77416C19.1143 2.40804 16.8996 2.40841 15.5345 3.775L4.13748 15.1847Z"
      fill="#272A34"
      stroke="url(#paint3_linear_926_3573)"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <defs>
      <linearGradient
        id="paint0_linear_926_3573"
        gradientUnits="userSpaceOnUse"
        x1="15.5395"
        x2="9.88264"
        y1="8.68267"
        y2="14.3395"
      >
        <stop stopColor="#009BFF" />
        <stop offset="1" stopColor="#5AE0FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_926_3573"
        gradientUnits="userSpaceOnUse"
        x1="8.51047"
        x2="6.15345"
        y1="7.31048"
        y2="9.6675"
      >
        <stop stopColor="#009BFF" />
        <stop offset="1" stopColor="#5AE0FF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_926_3573"
        gradientUnits="userSpaceOnUse"
        x1="17.2961"
        x2="14.9391"
        y1="16.7391"
        y2="19.0962"
      >
        <stop stopColor="#009BFF" />
        <stop offset="1" stopColor="#5AE0FF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_926_3573"
        gradientUnits="userSpaceOnUse"
        x1="12.9499"
        x2="12.9499"
        y1="1.30001"
        y2="21.3"
      >
        <stop stopColor="#009BFF" />
        <stop offset="1" stopColor="#5AE0FF" />
      </linearGradient>
    </defs>
  </svg>
);
